// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import {useEffect, useMemo, useRef, useState} from 'react';
import {use_qs} from '../../lib/use_qs';
// @ts-ignore
import {get_filename, get_exe_link} from '../../install_links.js';
// @ts-ignore
import ga from '../../ga.js';
import {use_browser} from '../../lib/use_browser';
import {perr_www_visit} from 'hola_pub_util';
import {guess_os_and_version} from '../../client_hints_global';
import {Installer_ws} from '../../join_network/installer_ws';

interface i_use_after_download_props {
    browser?: boolean;
    short_len?: number | object_of<number>;
    install_timeout?: number;
}

export const use_after_download = (props: i_use_after_download_props = {})=>{
    const {browser, short_len = {}, install_timeout} = props;
    const change_step_timer = useRef<number>();
    let b = use_browser();
    const qs = use_qs();
    const is_browser = browser||qs.browser=='1'||b=='safari';
    if (['opera', 'chrome', 'edge', 'firefox'].indexOf(b)==-1)
        b = 'chrome';
    const title = b.toUpperCase()[0] + b.substring(1);
    const step = qs.s;
    const [active_step, set_active_step] = useState(step);
    const link = get_exe_link({hola_browser: is_browser});
    const filename = qs.filename || get_filename({hola_browser: is_browser});
    const len = typeof short_len=='number' ? short_len : short_len[b];
    const shortname = !len || filename.length<=len ? filename :
        `${filename.slice(0, len-6)}...${filename.slice(-3)}`;
    const on_click = ()=>{
      ga.ga_track_download_send('exe', 'after_download_page',
        link, null, undefined, {by_link: true, hola_browser: is_browser});
    };
    const sys = guess_os_and_version();
    const next_step = ()=>{
        clearTimeout(change_step_timer.current);
        if (!document.hasFocus())
            document.title = 'Last Step';
        set_active_step('end');
        window.history.pushState({}, null, '/after_download?s=end'
             + (is_browser ? '&browser=1' : ''));
    };
    useEffect(()=>{
        perr_www_visit({id: `www_install_flow_step_${step}_visit`});
        if (step=='install' && install_timeout)
        {
            change_step_timer.current = +setTimeout(next_step,
                install_timeout);
        }
    }, [step]);
    const initial_title = document.title;
    const iws = useMemo(()=>{
        return new Installer_ws({onmessage: data=>{
            if (!data || !data.cmd)
                return;
            const cmds = {
                'agreed': on_user_agreed,
            };
            if (cmds.hasOwnProperty(data.cmd))
                cmds[data.cmd]();
            iws.send({ok: true});
        }});
    }, []);
    const on_user_agreed = ()=>{
        next_step();
    };
    const on_focus = ()=>{
        document.title = initial_title;
    };
    useEffect(()=>{
        window.addEventListener('focus', on_focus);
        return ()=>{
            window.removeEventListener('focus', on_focus);
        };
    }, []);
    return {step, os: sys.os, b, title, is_browser, link, filename, shortname,
        on_click, active_step};
};
